module.exports = __webpack_public_path__ + "static/media/All Research.601343db.xlsx";